"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var Figure = styled_1["default"].figure(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  iframe {\n    max-width: 100%;\n  }\n"], ["\n  iframe {\n    max-width: 100%;\n  }\n"])));

function Youtube(_a) {
  var id = _a.id;
  if (!id) return react_1["default"].createElement("div", null);
  return react_1["default"].createElement(Figure, {
    className: "my-8 flex items-center justify-center text-center"
  }, react_1["default"].createElement("iframe", {
    className: "shadow-lg",
    width: "560",
    title: "YouTube Video " + id,
    height: "315",
    src: "https://www.youtube-nocookie.com/embed/" + id,
    style: {
      border: 0
    },
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }));
}

exports.Youtube = Youtube;
var templateObject_1;